/**
 * @generated SignedSource<<39ba3f182bd0f151ffabe771aeda41df>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OtherHelp_viewer$data = {
  readonly getHelpTopic: {
    readonly isOtherIssue: boolean | null;
    readonly showChannelEmail: boolean | null;
    readonly showChannelLiveChat: boolean | null;
    readonly showChannelMessage: boolean | null;
    readonly showChannelWhatsApp: boolean | null;
  } | null;
  readonly loggedInBuyerSupportChat?: {
    readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_supportChat">;
  } | null;
  readonly loggedOutBuyerSupportChat?: {
    readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_supportChat">;
  } | null;
  readonly seller?: {
    readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_seller">;
  } | null;
  readonly sellerSupportChat?: {
    readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_supportChat">;
  } | null;
  readonly user?: {
    readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_user">;
  } | null;
  readonly " $fragmentType": "OtherHelp_viewer";
};
export type OtherHelp_viewer$key = {
  readonly " $data"?: OtherHelp_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"OtherHelp_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "useSupportChat_supportChat"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasSellerId"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "isLoggedOutUser"
    },
    {
      "kind": "RootArgument",
      "name": "isSeller"
    },
    {
      "kind": "RootArgument",
      "name": "orderId"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    },
    {
      "kind": "RootArgument",
      "name": "topicKey"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "OtherHelp_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isSeller",
          "variableName": "isSeller"
        },
        {
          "kind": "Variable",
          "name": "orderId",
          "variableName": "orderId"
        },
        {
          "kind": "Variable",
          "name": "topicKey",
          "variableName": "topicKey"
        }
      ],
      "concreteType": "GetHelpTopic",
      "kind": "LinkedField",
      "name": "getHelpTopic",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showChannelLiveChat",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showChannelWhatsApp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showChannelMessage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showChannelEmail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOtherIssue",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "loggedInBuyerSupportChat",
          "args": [
            {
              "kind": "Literal",
              "name": "touchpoint",
              "value": "Buyer_Messaging"
            }
          ],
          "concreteType": "SupportChatQuery",
          "kind": "LinkedField",
          "name": "supportChat",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": "supportChat(touchpoint:\"Buyer_Messaging\")"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useSupportChat_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isLoggedOutUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "loggedOutBuyerSupportChat",
          "args": [
            {
              "kind": "Literal",
              "name": "touchpoint",
              "value": "Guest_Buyer_Messaging"
            }
          ],
          "concreteType": "SupportChatQuery",
          "kind": "LinkedField",
          "name": "supportChat",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": "supportChat(touchpoint:\"Guest_Buyer_Messaging\")"
        }
      ]
    },
    {
      "condition": "isSeller",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "sellerSupportChat",
          "args": [
            {
              "kind": "Literal",
              "name": "touchpoint",
              "value": "Seller_Messaging"
            }
          ],
          "concreteType": "SupportChatQuery",
          "kind": "LinkedField",
          "name": "supportChat",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": "supportChat(touchpoint:\"Seller_Messaging\")"
        }
      ]
    },
    {
      "condition": "hasSellerId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "sellerId",
              "variableName": "sellerId"
            }
          ],
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useSupportChat_seller"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "036985f2e9f0fcf2162a558ec1d92496";

export default node;
